import update from 'immutability-helper';
import { FormActivationBcaVaGetRsData } from 'src/models/Client';
import { ActionType, defaultAction } from 'src/redux/types';
import { DEFAULT_VALUE, MAX_STEPS, VaType } from '../constants';
import { FormActivationBcaVaData } from '../types';
import { ACTION_TYPES } from './types';

export type FormActivationBcaVaStateData = {
  data: FormActivationBcaVaData;
  isLoading: boolean;
  error?: string;
};

export type FormActivationBcaVaState = {
  currentStep: number;
  data: FormActivationBcaVaStateData;
  isSubmitting: boolean;
};

const initialState: FormActivationBcaVaState = {
  currentStep: 1,
  data: {
    data: DEFAULT_VALUE,
    isLoading: false,
  },
  isSubmitting: false,
};

export default (
  state = initialState,
  { payload, type }: ActionType = defaultAction,
) => {
  switch (type) {
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_RESET_STATE:
      return initialState;
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SET_CURRENT_STEP: {
      let { currentStep: currentPaymentActivationStep } = state;
      if (payload >= 0 && payload <= MAX_STEPS - 1) {
        currentPaymentActivationStep = payload;
      }
      return update(state, {
        currentStep: {
          $set: currentPaymentActivationStep,
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SET_CURRENT_STEP_NEXT: {
      const { currentStep: currentPaymentActivationStep } = state;
      return update(state, {
        currentStep: {
          $set: currentPaymentActivationStep + 1,
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SET_CURRENT_STEP_BACK: {
      const { currentStep: currentPaymentActivationStep } = state;
      return update(state, {
        currentStep: {
          $set: currentPaymentActivationStep - 1,
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_UPDATE: {
      return update(state, {
        data: { data: { $merge: payload } },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_LOAD_DATA: {
      return update(state, {
        data: {
          isLoading: {
            $set: true,
          },
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SAVE_DATA:
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SUBMIT_DATA: {
      return update(state, {
        isSubmitting: {
          $set: true,
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_LOAD_DATA_SUCCESS: {
      const { data } = payload as FormActivationBcaVaGetRsData;
      const addressArr = data?.businessAddress?.split(', ') ?? [];
      const vaType = [];
      if (data?.vaCloseAmount) {
        vaType.push(VaType.CloseAmount);
      }
      if (data?.vaOpenAmount) {
        vaType.push(VaType.OpenAmount);
      }
      return update(state, {
        data: {
          data: {
            $set: {
              companyName: data?.businessName ?? '',
              brandName: data?.brandName ?? '',
              businessAddress: addressArr[0] ?? '',
              businessAddressSubDistrict: addressArr[1] ?? '',
              businessAddressDistrict: addressArr[2] ?? '',
              businessAddressCity: addressArr[3] ?? '',
              businessAddressProvince: addressArr[4] ?? '',
              businessAddressPostalCode: addressArr[5] ?? '',
              businessEstablishedDate: data?.businessEstablishedDate ?? '',
              businessIndustry: data?.businessSector ?? '',
              businessLink: data?.businessLink ?? '',
              businessTaxpayerId: data?.businessTaxpayerId ?? '',
              picEmail: data?.companyPicEmail ?? '',
              picName: data?.companyPicName ?? '',
              picPhoneNumber: data?.companyPicPhoneNumber ?? '',
              picPosition: data?.companyPicPosition ?? '',
              accountName: data?.accountName ?? '',
              accountNumber: data?.cardNumber ?? '',
              vaType,
              isSubmitted: data?.submitted ?? false,
            },
          },
          isLoading: {
            $set: false,
          },
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_LOAD_DATA_FAILED: {
      return update(state, {
        data: {
          error: {
            $set: payload.message,
          },
          isLoading: {
            $set: false,
          },
        },
      });
    }
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SAVE_DATA_SUCCESS:
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SUBMIT_DATA_SUCCESS:
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SAVE_DATA_FAILED:
    case ACTION_TYPES.FORM_PAYMENT_ACTIVATION_BCA_SUBMIT_DATA_FAILED: {
      return update(state, {
        isSubmitting: {
          $set: false,
        },
      });
    }
    default:
      return state;
  }
};
